import React, { useEffect } from 'react';

/**
 * GeolocationComponent - Handles geolocation functionality
 * 
 * This component manages requesting and processing user location data.
 */
const GeolocationComponent = ({
  geolocationRequested,
  setGeolocationRequested,
  setIsUsingGeolocation,
  setIsLoadingGeolocation,
  handleGeolocationCoverageCheck,
  setSearchQuery,
  searchInputRef
}) => {
  // Request geolocation on component mount
  useEffect(() => {
    // Check if geolocation has already been requested in this session
    const geolocationAlreadyRequested = localStorage.getItem('geolocationRequested');
    
    // Only request geolocation once per user session
    if (!geolocationRequested && !geolocationAlreadyRequested) {
      setGeolocationRequested(true);
      // Store in localStorage to persist across page refreshes
      localStorage.setItem('geolocationRequested', 'true');
      
      // Check if geolocation is supported
      if (navigator.geolocation) {
        setIsLoadingGeolocation(true);
        
        // Ask for permission and get coordinates
        navigator.geolocation.getCurrentPosition(
          // Success callback
          (position) => {
            setIsUsingGeolocation(true);
            setIsLoadingGeolocation(false);
            const coords = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            console.log('Got geolocation coordinates:', coords);
            
            // Perform coverage check with coordinates
            handleGeolocationCoverageCheck(coords);
            
            // Set a placeholder for the address field
            setSearchQuery('Using your current location (approximate)');
            if (searchInputRef.current) {
              searchInputRef.current.disabled = true;
            }
          },
          // Error callback
          (error) => {
            console.error('Geolocation error:', error);
            setIsLoadingGeolocation(false);
            // Don't show an error, just silently fail and let the user enter an address manually
          },
          // Options
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
        );
      }
    }
  }, [
    geolocationRequested, 
    setGeolocationRequested, 
    setIsUsingGeolocation, 
    setIsLoadingGeolocation, 
    handleGeolocationCoverageCheck, 
    setSearchQuery, 
    searchInputRef
  ]);

  // This component doesn't render anything visible
  return null;
};

export default GeolocationComponent;